import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-time-scan-settings-bar",
	templateUrl: "./time-scan-settings-bar.component.html",
	styleUrls: ["./time-scan-settings-bar.component.css"],
})
export class TimeScanSettingsBarComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() TimeScanTypeID: number = 1;
	SelectedTimeScanType: any;
	@Input() lstTimeScanType: any = [];

	@Output() UpdateType: EventEmitter<any> = new EventEmitter();
	@Output() CloseSettings: EventEmitter<any> = new EventEmitter();

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////
	UpdateData() {
		if (this.lstTimeScanType.length > 0 && this.TimeScanTypeID > 0) {
			for (var z = 0; z < this.lstTimeScanType.length; z++) {
				var next = this.lstTimeScanType[z];

				if (next.TimeScanTypeID == this.TimeScanTypeID) {
					this.SelectedTimeScanType = next;
				}
			}
		}
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onSet() {
		this.UpdateType.emit(this.SelectedTimeScanType);
	}

	onClose() {
		this.CloseSettings.emit(true);
	}

	/////////////////////////////////////////////////////////////////
}
